
<div class="order-contact-container">
  <debtor-panel-loading-spinner [isLoading]="store.isLoading()" />
  @if(store.isError()) {
    <debtor-panel-error
        (reloadRequested)="handleReload()"
      />
  } @else {
    <debtor-panel-common-nav-bar
      (navigateTo)="navigateToDashboard()"
    />
    <div class="order-contact-panel">
      <div class="row">
        <h2 class="h2 h2--no-margin">{{ 'order-contact.contact-order' | translate }}</h2>
      </div>
      @if (store.form(); as form) {
        <form [formGroup]="form">
          <debtor-panel-stepper #appStepper [indexValue]="store.formStep()" ngSkipHydration>
            <cdk-step>
              <debtor-panel-order-contact-data-input
                [formGroup]="form"
                [cases]="store.cases()"
                [phoneNumbers]="store.phoneNumbers()"
              >
              </debtor-panel-order-contact-data-input>
              <div class="row">
                <button mat-flat-button class="btn-common confirm-btn" (click)="confirmData()" [disabled]="!form.valid">
                  {{ 'order-contact.contact-order' | translate }}
                  @if(!form?.valid){
                    <span id="submit-disabled-info" class="sr-only">
                    {{ 'alt-for-img.case-assignment.btn-visibility' | translate }}
                    </span>
                  }
                </button>
              </div>
            </cdk-step>
            <cdk-step>
              <debtor-panel-order-contact-confirmation
                [formData]="store.contactFormData()"
                [dateString]="store.confirmationDateText()"
                [case]="store.caseDto()"
              >
              </debtor-panel-order-contact-confirmation>
              <div class="row first-button">
                <button mat-flat-button class="btn-common confirm-btn" (click)="submit()">{{ 'order-contact.confirm-btn' | translate }}</button>
              </div>
              <div class="row">
                <button mat-flat-button class="btn-border confirm-btn" (click)="previousPage()">{{ 'order-contact.back-to-edit' | translate }}</button>
              </div>
            </cdk-step>
            <cdk-step>
              <debtor-panel-order-contact-success
               [date]="store.confirmation()"
               [case]="store.caseDto()"
              >
              </debtor-panel-order-contact-success>
               <div class="row">
                <button mat-flat-button class="btn-common confirm-btn" (click)="navigateToDashboard()">{{ 'order-contact.back-to-pulpit-btn' | translate }}</button>
              </div>
            </cdk-step>
          </debtor-panel-stepper>
        </form>
      }
    </div>
  }
</div>